import initTechReportPicker from "components/jiffy/tech-report-picker/tech-report-picker";

document.addEventListener("DOMContentLoaded", () => {
  initTechReportPicker();
});

document.addEventListener("turbolinks:load", () => {
  initTechReportPicker();
});
